import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Customer } from '../../../../../../../models/customer';
import { AccountService } from '../../../../../../../services/account/account.service';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { Challenge, ChallengeStatus } from '../../../../../../../models/challenge';
import { ChallengeService } from '../../../../../../../services/challenge/challenge.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-add-customer-to-challenge-modal',
  templateUrl: './add-customer-to-challenge-modal.component.html',
  styleUrls: ['./add-customer-to-challenge-modal.component.css']
})
export class AddCustomerToChallengeModalComponent implements OnInit {

  @Input() customer: Customer;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public selectedChallengeId: number = null;

  public challengeList: Challenge[];

  public loadingChallenges = false;
  public loadingSubmit = false;
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    private accountService: AccountService,
    private challengeService: ChallengeService,
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  ngOnInit() {
    this.loadChallenges();
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.challengeService
      .addCustomerToChallenge(
        this.customer.id,
        this.selectedChallengeId
      )
      .then(() => {
        this.savedCallback({
          text: 'Customer added to challenge.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add customers to challenges.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadChallenges() {
    this.loadingChallenges = true;

    this.challengeService
      .getChallenges(1, 100, {status: ChallengeStatus.active})
      .then(response => {
        this.challengeList = response.results;
        if (this.challengeList.length > 0) {
          this.selectedChallengeId = this.challengeList[0].id;
        }
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingChallenges = false; });
  }

}
